// extracted by mini-css-extract-plugin
export default {"wrapper":"introduction6_wrapper__hxH45","button":"introduction6_button__k+EBP"};